export default __webpack_public_path__ + "static/media/duration.26c3a992.svg";